import InfoLine from '../components/InfoLine';
import Section from '../components/Section';

const SectionEducation = () => (
  <Section title="Formation" odd>
    <InfoLine title="Staffordshire University, UK">
      Master, Computer Science
      {/* (2009 – 2011) */}
    </InfoLine>
    <InfoLine title="Ecole Centrale d’Electronique, Paris">
      Prépa intégrée, cursus international
      {/* (2006 – 2009) */}
    </InfoLine>
    <InfoLine title="Lycée des Francs Bourgeois, Paris">Bac Scientifique{/* (2006) */}</InfoLine>
  </Section>
);

export default SectionEducation;
